import { checkSusscessRequest } from 'services/api';
import nftServices from 'services/nft';

export const useListForSaleNFT = () => {
  const handleListForSaleNFT = async (
    id: string,
    data: any,
    {
      onSuccess,
      onError,
      onErrorShowModal,
    }: { onSuccess: () => void; onError: () => void; onErrorShowModal: () => void },
  ) => {
    try {
      const response = await nftServices.handleListForSaleNFT(id, data);
      if (checkSusscessRequest(response)) {
        onSuccess && onSuccess();
      } else if (response?.data?.code === 'E36') {
        onErrorShowModal && onErrorShowModal();
      } else {
        onError && onError();
      }
    } catch (error) {
    } finally {
    }
  };

  return {
    onListForSaleNFT: handleListForSaleNFT,
  };
};
